// Design shows at most three bid-objective avatars before the availability counter.
const VISIBLE_AVATAR_CAP = 3;
// Reported availability covers a wider pool than the job itself, so it is scaled down.
const AVAILABILITY_DIVISOR = 3;
// Scaled availability collapses to "+99" once it reaches this many pros.
const AVAILABILITY_DISPLAY_CAP = 100;
const MAX_COUNTER = 99;

export interface ProsBannerCounts {
  avatarCount: number;
  // The banner's +X; hidden when zero or below
  extraAvailable: number;
}

const getExtraAvailable = (bidObjective: number, availableProfessionals?: number): number => {
  if (availableProfessionals === undefined) {
    return 0;
  }

  const scaledAvailable = Math.floor(availableProfessionals / AVAILABILITY_DIVISOR);

  return scaledAvailable >= AVAILABILITY_DISPLAY_CAP ? MAX_COUNTER : scaledAvailable - bidObjective;
};

export const getProsBannerCounts = (bidObjective: number, availableProfessionals?: number): ProsBannerCounts => ({
  avatarCount: Math.min(bidObjective, VISIBLE_AVATAR_CAP),
  extraAvailable: getExtraAvailable(bidObjective, availableProfessionals)
});

// Undefined when the banner shows no +X, so the side panel keeps the raw count
export const getBannerAlignedProsAvailable = (bidObjective: number, availableProfessionals?: number): number | undefined => {
  const { extraAvailable } = getProsBannerCounts(bidObjective, availableProfessionals);

  return extraAvailable > 0 ? bidObjective + extraAvailable : undefined;
};
